/**
 * AUTO-GENERATED — DO NOT EDIT.
 * Source: sdk.manifest.yml + openapi.json.
 * Regenerate with: pnpm gen
 */

import { createMutationHook } from '../../core/factories/createMutation.js';
import type { ClaimGiftAuthorizeResponse, ClaimGiftAuthorizeVars } from '../openapi-types.gen.js';

export type { ClaimGiftAuthorizeResponse, ClaimGiftAuthorizeVars } from '../openapi-types.gen.js';

export const useClaimGiftAuthorize = createMutationHook<ClaimGiftAuthorizeVars, ClaimGiftAuthorizeResponse, unknown>({
  specName: 'useClaimGiftAuthorize',
  path: '/v1/gifts/claim/authorize',
  method: 'POST',
  resolveUrl: (vars: ClaimGiftAuthorizeVars) => `/v1/gifts/claim/authorize`,
  buildBody: (vars: ClaimGiftAuthorizeVars) => ({ opaqueId: vars.opaqueId, destinationWalletPubkey: vars.destinationWalletPubkey }),
  parseResponse: (raw: unknown): ClaimGiftAuthorizeResponse => raw as ClaimGiftAuthorizeResponse,
  
  
  
});
